import { useCallback, useState } from 'react';

interface ActionError {
    error: unknown;
    clear: () => void;
    run: (action: () => Promise<unknown>) => Promise<void>;
}

export function useActionError(): ActionError {
    const [error, setError] = useState<unknown>(null);

    const clear = useCallback(() => setError(null), []);

    const run = useCallback(async (action: () => Promise<unknown>) => {
        setError(null);
        try {
            await action();
        } catch (caught) {
            setError(caught);
        }
    }, []);

    return { error, clear, run };
}
